import React, { useEffect, useRef } from "react"
import { Box } from "@kohler-dsm-library/kohler-core"
import styles from "@/components/Remedy/components/BathLogoVideo/BathLogoVideo.module.scss"
import {
  handleVideoEndedAnalytics,
  handleVideoPlayedAnalytics,
} from "@/components/Remedy/components/analytics"

export const BathLogoVideo = () => {
  const animatedVideoContainerRef = useRef(null)
  const loopingVideoContainerRef = useRef(null)
  const videoContainerRef = useRef(null)
  const [showAnimatedVideo, setShowAnimatedVideo] = React.useState(true)
  const [showLoopingVideo, setShowLoopingVideo] = React.useState(false)

  useEffect(() => {
    if (!animatedVideoContainerRef.current || !loopingVideoContainerRef.current)
      return
    const animatedVideo =
      animatedVideoContainerRef.current.querySelector("video")
    const loopingVideo = loopingVideoContainerRef.current.querySelector("video")

    if (!animatedVideo || !loopingVideo) return

    const sourceVideo = loopingVideo?.querySelector("source")

    const sourceVidoeAnimated = animatedVideo?.querySelector("source")

    const videoEndedListener = () => {
      loopingVideo.play()
      if (!window.animatedVideoPlayTriggered) {
        handleVideoPlayedAnalytics(
          "kohler x remedy",
          sourceVidoeAnimated?.src,
          true,
          "bathanimatedvideo"
        )
        window.animatedVideoPlayTriggered = true
      }
      handleVideoEndedAnalytics(
        "kohler x remedy",
        sourceVidoeAnimated?.src,
        true,
        "bathanimatedvideo"
      )
      handleVideoPlayedAnalytics(
        "kohler x remedy",
        sourceVideo?.src,
        true,
        "bathloopvideo"
      )
      setShowAnimatedVideo(0)
      setShowLoopingVideo(1)

      animatedVideo.removeEventListener("ended", videoEndedListener)
    }

    animatedVideo.addEventListener("ended", videoEndedListener)

    const handleIntersection = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          animatedVideo.play()
          observer.unobserve(animatedVideo)
        }
      })
    }

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: [0.35],
    })

    observer.observe(animatedVideo)

    return () => {
      observer.unobserve(animatedVideo)
    }
  }, [])

  useEffect(() => {
    if (!videoContainerRef.current) return

    const videoContainer = videoContainerRef.current
    const sectionRect = videoContainer.getBoundingClientRect()
    const sectionTopOffset = sectionRect.top - 300

    const scrollListener = () => {
      const value = Math.min(
        10,
        window.scrollY > sectionTopOffset
          ? (window.scrollY - sectionTopOffset) / 20
          : 0
      )

      videoContainer.style.clipPath = `polygon(
        calc(10% - ${value}%) calc(10% - ${value}%),
        calc(90% + ${value}%) calc(10% - ${value}%),
        calc(90% + ${value}%) calc(90% + ${value}%),
        calc(10% - ${value}%) calc(90% + ${value}%)
      )`
    }

    window.addEventListener("scroll", scrollListener)

    return () => {
      window.removeEventListener("scroll", scrollListener)
    }
  }, [])

  return (
    <Box
      component="section"
      className={styles["pxp-bath-logo-video-container"]}
      mod="charcoal"
    >
      <div className={styles["__video-container"]} ref={videoContainerRef}>
        <div
          ref={animatedVideoContainerRef}
          style={{ display: showAnimatedVideo ? "block" : "none" }}
          dangerouslySetInnerHTML={{
            __html: `
          <video preload="metadata" muted playsinline id="bathanimatedvideo">
            <source src="https://kohler.scene7.com/is/content/${
              process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes("www.kohler.com")
                ? "kohlergbhprod"
                : "kohlergbhqa"
            }/PXP/Bath.mp4" />
          </video>
        `,
          }}
        />
        <div
          ref={loopingVideoContainerRef}
          style={{ display: showLoopingVideo ? "block" : "none" }}
          dangerouslySetInnerHTML={{
            __html: `
          <video preload="metadata" muted loop playsinline id="bathloopvideo">
           <source src="https://kohler.scene7.com/is/content/${
             process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes("www.kohler.com")
               ? "kohlergbhprod"
               : "kohlergbhqa"
           }/PXP/BathLoop.mp4" />
          </video>
        `,
          }}
        />
      </div>
    </Box>
  )
}
